import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { fixedValues } from 'src/app/shared/constants/fixed-values.enum';
import { CommonService } from '../../../services/common.service';
import { LangService } from 'src/app/core/services/lang.service';
import { GridService } from 'src/app/shared/services/grid.service';

@Component({
  selector: 'app-nature-list',
  templateUrl: './../../../templates/forms/modals/nature-list.component.html',
})
export class NatureListComponent implements OnInit {
  @Input()
  modalShow: boolean = true;

  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  dataObj: any;

  columnDefs = [];
  colObj;
  grid: any;
  gridId: string = "NatureListGrid"
  natureList: any[] = [];
  searchFields: any[] = ['NATURE_NAME', 'NATURE_CODE', 'NATURE_NO'];
  public searchString;
  constructor(private dataService: CommonService,
    public langService: LangService,
    public gridService: GridService) {
    this.colObj = [
      { headerName: langService.langData.natureName, field: 'NATURE_NAME', sortable: true, resizable: true, hide: false },
      { headerName: langService.langData.natureCode, field: 'NATURE_CODE', sortable: true, resizable: true, hide: false },
      { headerName: langService.langData.natureNo, field: 'NATURE_NO', sortable: true, resizable: true, hide: false }
    ];
  }


  ngOnInit() {
    this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId);
  }
  onGridReady(grid) {
    this.grid = grid;
    this.gridService.sizeColumnsToFit(grid, this.gridId);
    this.dataService.getAccountCategories()
      .subscribe(arg => { this.natureList = arg.body });
  }
  itemClick(_item) {
    this.modalShow = false;
    this.dataObj = _item;
    this.submit.next();
  }

}
